import { Editor, RawEditorOptions } from 'tinymce';
import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { EDITOR_TINYMCE, EditorConfigService } from '../../editor/editor-config.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-textarea',
  template: `
    <textarea *ngIf="!to.editor || !tinymceConfig; else tinymce"
      class="form-control"
      [rows]="rows"
      [ngClass]="classNames"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [attr.x-autocompletetype]="to.autoCompleteType"
      [attr.autocompletetype]="to.autoCompleteType"
      [placeholder]="to.placeholder"
      (blur)="to.onBlur && to.onBlur(formControl.value)"
      [inputFocus]="to.inputFocus"
    >
		</textarea>
    
    <ng-template #tinymce>
      <editor [ngClass]="classNames" [formlyAttributes]="field" [init]="tinymceConfig" [formControl]="formControl" (onRemove)="onRemove($event)"></editor>  
    </ng-template>
	`
})
export class FormlyFieldTextareaComponent extends ExtraFieldType implements OnInit {
  public tinymceConfig:RawEditorOptions;
  public rows:number;

  constructor(
    private editorConfigService:EditorConfigService,
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.TEXTAREA, <string>this.key, this.to.label);
    this.rows = this.to.rows || 4;
    this.initEditor();

    // register listener
    this.listen();
  }

  private initEditor():void {
    if(this.to.editor === EDITOR_TINYMCE) {
      this.tinymceConfig = this.editorConfigService.getConfig(this.to.editorCode);
    }
  }

  public onRemove(e: { event: Event, editor: Editor } ): void {
    // fix: tinymce not destroyed properly in dialog
    e.event.stopImmediatePropagation();
  }
}